var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherSettingsAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34095_79553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34915 1.88023C7.40808 1.56468 7.68351 1.33594 8.00451 1.33594C8.32551 1.33594 8.60094 1.56468 8.65987 1.88023L9.36057 5.58573C9.46242 6.12488 9.88414 6.5466 10.4233 6.64845L14.1288 7.34915C14.4443 7.40808 14.6731 7.68351 14.6731 8.00451C14.6731 8.32551 14.4443 8.60094 14.1288 8.65987L10.4233 9.36057C9.88414 9.46242 9.46242 9.88414 9.36057 10.4233L8.65987 14.1288C8.60094 14.4443 8.32551 14.6731 8.00451 14.6731C7.68351 14.6731 7.40808 14.4443 7.34915 14.1288L6.64845 10.4233C6.5466 9.88414 6.12488 9.46242 5.58573 9.36057L1.88023 8.65987C1.56468 8.60094 1.33594 8.32551 1.33594 8.00451C1.33594 7.68351 1.56468 7.40808 1.88023 7.34915L5.58573 6.64845C6.12488 6.5466 6.5466 6.12488 6.64845 5.58573L7.34915 1.88023Z",
    stroke: "#6B4EE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 1.33594V3.99879",
    stroke: "#6B4EE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6629 2.66406H12",
    stroke: "#6B4EE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 13.3314C1.33594 12.5961 1.93204 12 2.66737 12C3.40269 12 3.99879 12.5961 3.99879 13.3314C3.99879 14.0668 3.40269 14.6629 2.66737 14.6629C1.93204 14.6629 1.33594 14.0668 1.33594 13.3314Z",
    stroke: "#6B4EE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34095_79553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherSettingsAi);
export default __webpack_public_path__ + "static/media/otherSettingsAi.8b0cee5e334d4bdb1041115dab1b21ec.svg";
export { ForwardRef as ReactComponent };